export default __webpack_public_path__ + "static/media/may.58259627.png";